import React, { FC } from "react"
import Gallery from "@components/Gallery"
import { PageSection } from "@components/styles"

const StrapiGallery: FC<Queries.StrapiComponentSectionsGallery> = ({
    images
}) => {
    return images?.length > 0 ? <PageSection>
        <Gallery images={images} />
    </PageSection> : null
}

export default StrapiGallery
